import { Plus } from "lucide-react";
import React from "react";
import { Filter, Search } from "../icons";

const HeaderInfo = ({
  title,
  desc,
  btnLabel,
  onAdd,
  btnIcon = true,
  isSearchBar = false,
  searchPlaceholder = "Search Categories",
  isFilters = false,
  showFilterButton = true,
  searchValue,
  onSearchChange,
  onFilterClick,
  hasSearchText = false,
  activeFilter,
  onFilterChange,
  extraFilters,
  extraButtons,
}) => {
  const filterTabs = [
    {
      label: "All Requests",
      value: "ALL",
    },
    {
      label: "Pending VP",
      value: "pending_vp",
    },
    {
      label: "Pending Central",
      value: "pending_central",
    },
    {
      label: "Approved",
      value: "approved_central",
    },
    {
      label: "Received",
      value: "recieved",
    },
    {
      label: "Rejected",
      value: "rejected_central",
    },
  ];
  return (
    <div>
      <div className="flex flex-wrap items-center gap-4 justify-between">
        <div>
          <h2 className="text-3xl lg:text-4xl leading-4 lg:leading-6 font-bold">
            {title}
          </h2>
          <div className="mt-3 text-lg lg:text-xl leading-6 lg:leading-[31px] text-[#878686]">
            {desc}
          </div>
        </div>
        <div className="flex gap-4 items-center">
          {extraButtons && extraButtons}
          {btnLabel && (
            <button
              onClick={onAdd}
              className="rounded-[10px] text-sm lg:text-base bg-[#6D4E8A] text-white flex items-center gap-1.5 lg:gap-2.5 py-2 lg:py-2.5 px-6 lg:px-[30.5px]"
            >
              {btnIcon && <Plus size={22} className="text-white size-4 lg:size-auto" />}
              <span className="">{btnLabel}</span>
            </button>
          )}
        </div>
      </div>

      {isSearchBar && (
        <div className="lg:ml-2.5 border border-[#D9D9D9] rounded-[10px] py-3 lg:py-4 px-3 lg:pl-6 lg:pr-4 mt-6 flex flex-wrap items-center justify-center gap-4">
          <div className="flex items-center flex-1 min-w-[250px] gap-2 py-3 px-2 lg:px-4 bg-[#EEEEEE40] rounded-[10px]">
            <Search />
            <input
              type="search"
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full bg-transparent outline-none text-black placeholder:text-[#878686]"
            />
          </div>

          {isFilters && (
            <div className="bg-[#EEEEEE40] rounded-[10px] py-2 px-3 flex flex-wrap justify-center gap-2 w-full lg:w-auto">
              {filterTabs.map((tab) => (
                <button
                key={tab.value}
                  onClick={() => onFilterChange?.(tab.value)}
                  className={`rounded-[10px] p-1 transition-all duration-200 ${
                    activeFilter === tab.value
                      ? "bg-white text-black"
                      : "bg-transparent text-[#878686]"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
              {extraFilters && <>{extraFilters}</>}
            </div>
          )}

          {showFilterButton && (
            <div className="w-full lg:w-auto flex justify-center">
              <button
                onClick={onFilterClick}
                className={`w-[138px] rounded-[10px] px-6 py-[11px] flex items-center justify-center gap-3 transition-all duration-200 ${
                  hasSearchText
                    ? "bg-[#6D4E8A] text-white border border-[#6D4E8A]"
                    : "bg-white text-[#878686] border border-[#DBD8D8]"
                }`}
              >
                <Filter />
                <span>Filter</span>
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HeaderInfo;
